// src/pages/PaginaEnConstruccion.tsx
export default function PaginaEnConstruccion() {
  return (
    <main className="grid min-h-screen place-items-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-2xl font-semibold text-gray-800 sm:text-3xl">
          Página en construcción dashboard comercial
        </h1>
        <p className="mt-2 text-sm text-gray-500">
          Volvé más tarde 😊
        </p>
      </div>
    </main> 
  );
}